module.exports = __webpack_public_path__ + "img/takeAndGoGray.ad870b05.svg";